angular.module('d3', [])
    .constant('d3', window.d3)
    .constant('defaultChartColors', [
        '#D0021B',
        '#00A560',
        '#B0009A',
        '#6600B2',
        '#F8C143',
        '#0090B9',
        '#E97700',
        '#B17600',
    ])